export const account = (prefix = '') => [
  {
    path: 'my-account',
    name: prefix ? `${prefix}/my-account` : 'my-account',
    meta: {
      available: true
    },
    component: () => import('@/portals/Application/MyAccount')
  },
  {
    path: 'my-account/change-password',
    name: prefix ? `${prefix}/my-account/change-password` : 'my-account/change-password',
    meta: {
      available: true
    },
    component: () => import('@/portals/Application/MyAccount/ChangePassword')
  },
  {
    path: 'my-account/quick-start-guide',
    name: prefix ? `${prefix}/my-account/quick-start-guide` : 'my-account/quick-start-guide',
    meta: {
      available: true
    },
    component: () => import('@/portals/Application/MyAccount/QuickStartGuide')
  }
];
